const rubFormatter = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 })

export const formatRub = value => {
  if (value == null) return '—'
  return `${rubFormatter.format(value)} ₽`
}

export const formatPercent = (value, fractionDigits = 1) => {
  if (value == null) return '—'
  const percent = value * 100
  return `${percent.toFixed(fractionDigits).replace('.', ',')} %`
}

const MONTHS_SHORT = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек']

const parseDate = iso => {
  if (!iso) return null
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? null : d
}

export const formatPeriod = period => {
  if (!period) return ''
  const from = parseDate(period.from)
  const to = parseDate(period.to)
  if (!from && !to) return ''
  if (from && to) {
    const sameMonth = from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()
    if (sameMonth) {
      return `${from.getDate()}–${to.getDate()} ${MONTHS_SHORT[from.getMonth()]} ${from.getFullYear()}`
    }
    return `${from.getDate()} ${MONTHS_SHORT[from.getMonth()]} – ${to.getDate()} ${MONTHS_SHORT[to.getMonth()]} ${to.getFullYear()}`
  }
  const single = from || to
  return `${single.getDate()} ${MONTHS_SHORT[single.getMonth()]} ${single.getFullYear()}`
}

export const planfixTaskUrl = id => {
  if (!id) return null
  return `https://myfests.planfix.com/task/${id}`
}

export const planfixPackUrl = packId => {
  if (!packId) return null
  return `https://myfests.planfix.com/?action=handbookdataview&handbook=45152&key=${packId}`
}

export const profitVariant = profit => {
  if (profit == null || profit === 0) return 'secondary'
  return profit > 0 ? 'success' : 'danger'
}

const toIsoDate = d => {
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const presetRange = name => {
  const today = new Date()
  if (name === 'thisMonth') {
    const from = new Date(today.getFullYear(), today.getMonth(), 1)
    const to = new Date(today.getFullYear(), today.getMonth() + 1, 0)
    return { from: toIsoDate(from), to: toIsoDate(to) }
  }
  if (name === 'lastMonth') {
    const from = new Date(today.getFullYear(), today.getMonth() - 1, 1)
    const to = new Date(today.getFullYear(), today.getMonth(), 0)
    return { from: toIsoDate(from), to: toIsoDate(to) }
  }
  if (name === 'quarter') {
    const from = new Date(today.getFullYear(), today.getMonth() - 2, 1)
    return { from: toIsoDate(from), to: toIsoDate(today) }
  }
  if (name === 'year') {
    const from = new Date(today.getFullYear(), today.getMonth() - 11, 1)
    return { from: toIsoDate(from), to: toIsoDate(today) }
  }
  return { from: '', to: '' }
}

export const roiVariant = roi => {
  if (roi == null) return 'secondary'
  if (roi < 1) return 'danger'
  if (roi < 2) return 'warning'
  return 'success'
}

export const formatRoi = roi => {
  if (roi == null) return '—'
  return `×${roi.toFixed(1).replace('.', ',')}`
}

export const formatPremiereDate = iso => {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return `${d.getDate()} ${MONTHS_SHORT[d.getMonth()]} ${d.getFullYear()}`
}

export const rollingMedian = (values, window) => {
  const n = values.length
  if (n === 0) return []
  let w = window
  if (w < 1) w = 1
  if (w > n) w = n
  const half = Math.floor(w / 2)
  const result = new Array(n)
  for (let i = 0; i < n; i += 1) {
    const start = Math.max(0, i - half)
    const end = Math.min(n - 1, i + half)
    const slice = values.slice(start, end + 1).sort((a, b) => a - b)
    const len = slice.length
    if (len % 2 === 1) {
      result[i] = slice[(len - 1) / 2]
    } else {
      result[i] = (slice[len / 2 - 1] + slice[len / 2]) / 2
    }
  }
  return result
}

export const flattenWeeks = weeks => {
  if (!Array.isArray(weeks)) return []
  const sortedWeeks = weeks.slice().sort((a, b) => {
    const aFrom = (a.period && a.period.from) || ''
    const bFrom = (b.period && b.period.from) || ''
    return bFrom.localeCompare(aFrom)
  })
  const result = []
  sortedWeeks.forEach(week => {
    const packs = Array.isArray(week.packs) ? week.packs.slice() : []
    result.push({
      kind: 'week',
      _weekId: week.id,
      _packsLeft: packs.length,
      ...week,
    })
    packs.sort((a, b) => (b.revenue || 0) - (a.revenue || 0))
    packs.forEach(pack => {
      result.push({
        kind: 'pack',
        _weekId: week.id,
        ...pack,
        id: week.id,
        name: week.name,
        period: week.period,
      })
    })
  })
  return result
}
